import React, { FC } from 'react';

import FormPage from 'src/presentation/components/pages/shared/FormPage';
import IdleTimingConfigForm from './IdleTimingConfigForm';
import idleTimingResource from 'src/actions/idleTiming/idleTimingResource';
import useDocumentResource from 'src/presentation/hooks/useDocumentResource';

const IdleTimingConfig: FC = () => {
  const { errors, loadingState, value } = useDocumentResource(idleTimingResource);
  const description = (
    <span>
      These settings determine the amount of idle time before an agent’s status is changed. Agents are considered idle
      when their mouse hasn&apos;t moved.{' '}
      <a target="_blank" rel="noopener noreferrer" href="https://help.gladly.com/docs/manage-agent-idle-time/">
        Learn more about managing idle timing
      </a>
      .
    </span>
  );
  return (
    <FormPage
      isLoading={loadingState === 'loading'}
      form={IdleTimingConfigForm}
      title="Idle Timing"
      description={description}
      item={value}
      errors={errors}
      resetErrors={idleTimingResource.actions.resetErrors}
      data-aid="admin-agent-config-page"
    />
  );
};

export default IdleTimingConfig;
